<template>
    <div id="fleet-create-view" class="view form-view">
        <h2>{{ $t('createFleet.title') }}</h2>
        <fleet-form :handler="createFleet" :form="form">
            <v-layout row slot="info">
                <div class="info-block">
                    {{ $t('createFleet.info') }}
                </div>
            </v-layout>
        </fleet-form>
    </div>
</template>

<script>
import FleetForm from './components/FleetForm'
import FleetApi from '@/api/FleetApi'
import toast from '../../plugins/izitoast'
import { mapGetters } from 'vuex'

const fleetApi = new FleetApi();

export default {
    name: 'CreateFleet',
    components: {
        FleetForm
    },
    data () {
        return {
            form: {
                name: '',
                parentFleet: null
            }
        }
    },
    computed: {
        ...mapGetters({
            getActiveOrganization: 'authModule/getActiveOrganization'
        })
    },
    methods: {
        async createFleet (form) {
            const response = await fleetApi.createFleet(form.name, this.getActiveOrganization)

            if (!response.isSuccess) {
                return
            }

            toast.success(this.$t('createFleet.successMassage'))

            if (this.hasAllRoles(['FleetUpdate'])) {
                this.$router.push('/settings/fleets/edit/' + response.payload)
            }
        }
    }
}
</script>

<style scoped lang="scss">
#fleet-create-view {
    .buttons {
        .right {
            .btn {
                justify-content: flex-end;
            }
        }
    }
}
</style>
